import "./without.css";

const WithoutSidebar = ({ children, footer = false, isLogin = false}) => {
  return (
    <>
      <div className={(isLogin ? "without-container": "without-background")}>
        <div className="parent-logoair">
          {
            isLogin &&
            <img src="/images/logo-irair.png" />
          }
        </div>
        {children}
        <div className="footer">
          {footer && (
            <>
              <a
                referrerpolicy="origin"
                target="_blank"
                href="https://trustseal.enamad.ir/?id=240686&amp;Code=dVExHeL6Y0Lg3hOUCkcD"
              >
                <img
                  referrerpolicy="origin"
                  src="/images/enamad.png"
                  alt=""
                  id="dVExHeL6Y0Lg3hOUCkcD"
                />
              </a>
              <div className="item">
                <a className="a1" href="https://www.iranair.com/about-us">
                  درباره ما
                </a>
                <a className="a1" href="https://www.iranair.com/contact-us">
                  ارتباط با ما
                </a>
                <a
                  className="a1"
                  href="http://www.iranair.com/terms-and-conditions"
                >
                  قوانین و مقررات
                </a>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default WithoutSidebar;
